import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';

const IconSleekSilhouetteChair = ({
  color = colorGray,
  width = '48',
  height = '48',
  className = '',
}) => {
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="10.6"
      y="7.6"
      width="7.8"
      height="23.8"
      rx="1.4"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="10.6"
      y="25.6"
      width="26.8"
      height="6.8"
      rx="1.4"
      fill="white"
      stroke={color}
      strokeWidth="1.2"
    />
    <line
      x1="37.4"
      y1="40"
      x2="37.4"
      y2="29"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect x="10" y="27" width="1" height="13" fill={color} />
  </svg>;
};

IconSleekSilhouetteChair.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

export default IconSleekSilhouetteChair;
